import React from 'react';
import { Pane } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Blocker } from '@leverege/molten/views';
import P from '@leverege/promise';
import { DataSources } from '@leverege/ui-attributes';
import { TheftRecoveryActive, TheftRecoveryInactive } from "./views/index.js"; // import TheftRecoveryEnding from './views/TheftRecoveryEnding'
// import { theftRecoveryRequestStates as THEFT_RECOVERY_REQUEST_STATES } from '../../../../constants'
import { jsx as _jsx } from "react/jsx-runtime";
export default class TheftRecoveryCard extends React.Component {
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
    this.userPermissionsLoad = P.deferred();
    this.state = {
      caseData: null,
      userHasAccess: false
    };
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps) {
    const prevItem = prevProps.sharedProps?.item;
    const {
      sharedProps: {
        item
      }
    } = this.props;
    if (prevItem?.data?.case?.id !== item?.data?.case?.id) {
      this.loadData();
    }
    this.getActionPermissions();
  }
  loadData() {
    this.loadCaseActions();
    if (this.caseActions) {
      GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        try {
          const {
            id: caseId,
            systemId
          } = this.caseActions;
          const {
            sharedProps: {
              item
            }
          } = this.props;
          const orgId = item?.data?.organization?.id;
          const companyId = item?.data?.company?.id;
          const locationId = item?.data?.location?.id;
          let theftCase;
          if (orgId) {
            theftCase = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('cases').obj(caseId).get();
          } else {
            theftCase = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('cases').obj(caseId).get();
          }
          this.setState({
            caseData: {
              id: theftCase.id,
              data: theftCase.data,
              ref: this.caseActions.parent().getInterfaceUrl(),
              type: 'case'
            }
          });
          this.initialLoad.resolve();
        } catch (error) {
          console.log({
            err: error
          });
        }
      });
    } else {
      this.initialLoad.resolve();
    }
  }
  loadCaseActions() {
    const {
      sharedProps: {
        item,
        actions
      }
    } = this.props;
    if (item?.data?.case?.id) {
      let ref = actions.getInterfaceUrl();
      if (ref.indexOf('assetsLocators') > -1) {
        ref = ref.replace('assetsLocators', 'cases');
        ref = ref.endsWith('cases') ? ref : trimRef(ref);
      } else if (ref.indexOf('assetLocators')) {
        ref = ref.replace('assetLocators', 'case');
        ref = ref.endsWith('case') ? ref : trimRef(ref);
      }
      const caseObj = {
        id: item.data.case.id,
        ref,
        type: 'case'
      };
      this.caseActions = DataSources.getActions(caseObj);
    }
  }
  getActionPermissions() {
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const {
          sharedProps: {
            item
          }
        } = this.props;
        const endpoint = item?.data?.case ? 'deactivate' : 'activate';
        const systemId = item?.systemId;
        const assetId = item?.id;
        const orgId = item?.data?.organization?.id;
        const companyId = item?.data?.company?.id;
        const locationId = item?.data?.location?.id;
        let res;
        if (orgId) {
          res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch(endpoint, null, {
            test: true
          });
        } else {
          res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch(endpoint, null, {
            test: true
          });
        }
        this.setState({
          userHasAccess: res.allowed === true
        });
        this.userPermissionsLoad.resolve();
      } catch (error) {
        console.log({
          msg: 'loadData',
          err: error
        });
        this.userPermissionsLoad.resolve();
      }
    });
  }
  renderChildren = () => {
    const {
      sharedProps: {
        item
      }
    } = this.props;
    const {
      caseData,
      userHasAccess
    } = this.state;

    // const theftRecoveryState = item?.data?.locator?.data?.theftRecoveryRequestMetadata?.state || 'ended'
    const inTheftRecoveryMode = item?.data?.case;
    if (inTheftRecoveryMode) {
      return /*#__PURE__*/_jsx(TheftRecoveryActive, {
        ...this.props,
        caseActions: this.caseActions,
        caseData: caseData,
        userHasAccess: userHasAccess
      });
    }
    return /*#__PURE__*/_jsx(TheftRecoveryInactive, {
      ...this.props,
      caseActions: this.caseActions,
      caseData: caseData,
      userHasAccess: userHasAccess
    });
  };
  render() {
    const matchContext = {
      client: 'WhyDoIHaveToDoThis'
    };
    return /*#__PURE__*/_jsx(Pane
    // variant="theftRecoveryCardContent"
    , {
      style: {
        padding: '0px 16px 16px 16px'
      },
      children: /*#__PURE__*/_jsx(Blocker, {
        matchContext: matchContext,
        context: this.props,
        hooks: [{
          execute: () => Promise.all([this.initialLoad, this.userPermissionsLoad])
        }],
        render: this.renderChildren
      })
    });
  }
}
function trimRef(ref) {
  const arr = ref.split('/');
  arr.pop();
  return arr.join('/');
}